var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 383.335,
    height: 231.402,
    viewBox: "0 0 383.335 231.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(-534.476 -20.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664",
    transform: "translate(593.277 20.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M737.255,220.207h-88.53a7.594,7.594,0,0,1-7.569-6.975c-4.36-53.372-8.142-100.278-13.175-156.808-.976-10.957,13.81-11.81,13.81-11.81l82.379.194a7.593,7.593,0,0,1,7.568,6.975C733.1,68.427,744.824,189.6,744.824,211.995A7.594,7.594,0,0,1,737.255,220.207Z",
    transform: "translate(-593.277 -20.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(34.262 23.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6673",
    "data-name": "Path 6673",
    d: "M744.824,211.995c0-1.821-.079-4.3-.222-7.323H647.34c.038.9.409,8.04,1.154,10.445a9.476,9.476,0,0,0,4.753,5.09h84.008A7.594,7.594,0,0,0,744.824,211.995Z",
    transform: "translate(-627.539 -44.219)",
    fill: "#fad3b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638",
    transform: "translate(24.256 71.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6674",
    "data-name": "Path 6674",
    d: "M652.19,116.335a.395.395,0,0,1,0-.79l72.124-.25h0a.395.395,0,0,1,0,.789l-72.125.251Z",
    transform: "translate(-651.795 -115.295)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639",
    transform: "translate(25.508 80.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6675",
    "data-name": "Path 6675",
    d: "M653.442,126.1a.395.395,0,0,1,0-.79l72.124-.251h0a.395.395,0,0,1,0,.79l-72.124.251Z",
    transform: "translate(-653.047 -125.061)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640",
    transform: "translate(26.761 90.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M654.7,135.868a.395.395,0,0,1,0-.79l72.124-.25h0a.395.395,0,0,1,0,.79l-72.124.25Z",
    transform: "translate(-654.3 -134.828)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641",
    transform: "translate(28.013 100.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M655.947,145.635a.4.4,0,0,1,0-.79l72.124-.25h0a.395.395,0,0,1,0,.79l-72.124.25Z",
    transform: "translate(-655.552 -144.595)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "translate(26.761 110.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M654.7,155.4a.395.395,0,0,1,0-.79l72.124-.25h0a.395.395,0,0,1,0,.79l-72.124.25Z",
    transform: "translate(-654.3 -154.362)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(28.013 119.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M655.947,165.169a.4.4,0,0,1,0-.79l72.124-.251h0a.395.395,0,0,1,0,.79l-72.124.251Z",
    transform: "translate(-655.552 -164.128)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M737.255,220.6h-88.53a8.032,8.032,0,0,1-7.962-7.338l-1.275-15.612c-3.787-46.4-7.364-90.237-11.9-141.193A9.277,9.277,0,0,1,629.75,49.3c3.944-4.568,11.69-5.065,12.018-5.084l82.4.193a8.033,8.033,0,0,1,7.962,7.338c.3,3.659,1.084,12.186,2.169,23.987,3.815,41.508,10.918,118.768,10.918,136.257a7.987,7.987,0,0,1-7.964,8.607ZM641.79,45.009c-.053,0-7.721.5-11.444,4.813a8.515,8.515,0,0,0-1.972,6.567c4.537,50.959,8.115,94.792,11.9,141.2L641.55,213.2a7.239,7.239,0,0,0,7.175,6.612h88.53a7.2,7.2,0,0,0,7.175-7.785c0-17.485-7.1-94.722-10.916-136.216-1.085-11.8-1.869-20.333-2.17-24a7.238,7.238,0,0,0-7.175-6.612Z",
    transform: "translate(-627.539 -44.22)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M647.818,211.85a.763.763,0,0,1,.214-.632c-.056-.526-.084-1.055-.1-1.584-.322-2.35-.687-4.676-.84-7.047a34.716,34.716,0,0,1-.127-6.464c-.1-1.456-.216-2.911-.4-4.358a64.2,64.2,0,0,1-.925-10.234,12.223,12.223,0,0,1-.235-2.893c-.068-1.542-.355-3.056-.351-4.6a.919.919,0,0,1,.11-.448c0-.164,0-.328-.005-.493a.749.749,0,0,1-.073-.2,15.166,15.166,0,0,1-.279-2.758.81.81,0,0,1,.142-.478c-.018-.184-.036-.369-.053-.554-.044-.268-.087-.535-.121-.8-.157-1.233-.222-2.478-.331-3.716-.271-3.088-.974-6.04-.773-9.161A.924.924,0,0,1,643.8,155c-.7-10.048-1.519-20.085-2.23-30.131-.584-5.08-1.024-10.173-1.474-15.268-.274-3.093-.481-6.193-.847-9.277a39.675,39.675,0,0,1-.613-8,.961.961,0,0,1,.114-.381c-.215-2.04-.385-4.088-.668-6.118a46.91,46.91,0,0,1-.526-4.785c-.057-1.587-.321-3.2-.265-4.786-.356-2.414-.527-4.849-.785-7.283-.365-3.449-.84-7.5-1.131-10.957-.219-2.6-.918-5.053-.113-7.6a9.086,9.086,0,0,1,3.059-4.161,9.014,9.014,0,0,1,1.059-1.127c-4.147.78-12.124,3.342-11.4,11.483,5.033,56.531,8.815,103.436,13.175,156.808a7.6,7.6,0,0,0,7.569,6.976l4.916.1C650.736,218.722,648.066,214.952,647.818,211.85Z",
    transform: "translate(-627.539 -44.219)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6682",
    "data-name": "Path 6682",
    d: "M684.824,91.789H653.279c-1.448,0-2.019-1.079-2.234-2.606a55.038,55.038,0,0,1-.675-6.264,2.364,2.364,0,0,1,2.448-2.7h30.739a2.664,2.664,0,0,1,2.835,2.726c.3,3.874.1.657.62,6.392C687.145,90.792,686.289,91.62,684.824,91.789Z",
    transform: "translate(-627.539 -44.219)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    d: "M725.285,91.789H693.739c-1.448,0-2.018-1.079-2.234-2.606a55.243,55.243,0,0,1-.674-6.264,2.364,2.364,0,0,1,2.448-2.7h30.739a2.664,2.664,0,0,1,2.835,2.726c.305,3.874.1.657.62,6.392A2.141,2.141,0,0,1,725.285,91.789Z",
    transform: "translate(-627.539 -44.219)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645",
    transform: "translate(7.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6684",
    "data-name": "Path 6684",
    d: "M647.613,207.3a.394.394,0,0,1-.393-.363c-1.262-15.7-2.469-31.682-3.638-47.135-2.647-35.023-5.385-71.239-8.935-106.741a8.374,8.374,0,0,1,2.163-6.349,7.583,7.583,0,0,1,5.626-2.491.395.395,0,0,1,0,.79,6.8,6.8,0,0,0-5.045,2.236,7.578,7.578,0,0,0-1.957,5.743c3.55,35.5,6.288,71.725,8.936,106.752,1.168,15.453,2.376,31.432,3.637,47.131a.4.4,0,0,1-.362.426Z",
    transform: "translate(-634.619 -44.219)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646",
    transform: "translate(19.354 159.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    d: "M655.78,220.6a8.082,8.082,0,0,1-8.048-7.34c-.082-1.011-.239-2.761-.4-4.541-.173-1.934-.35-3.9-.438-5a.4.4,0,0,1,.362-.425.391.391,0,0,1,.425.362c.089,1.1.265,3.065.438,5,.16,1.782.317,3.534.4,4.547a7.286,7.286,0,0,0,7.26,6.614.4.4,0,1,1,0,.79Z",
    transform: "translate(-646.894 -203.292)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647",
    transform: "translate(48.153 19.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    "data-name": "Path 6686",
    d: "M710.916,65.548H676.482a.79.79,0,1,1,0-1.58h34.434a.79.79,0,0,1,0,1.58Z",
    transform: "translate(-675.692 -63.968)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M666.145,75.477c-.367.04-.74.053-1.1.059q-6.333.109-12.655-.124a2.689,2.689,0,0,1-3.06-3.173l-.948-9.43c-.306-3.043.2-5.1,3.634-5.094l12.829.02a2.589,2.589,0,0,1,3.124,2.99q.507,5.2,1.013,10.4c.114,1.172.18,2.5-.615,3.4A3.335,3.335,0,0,1,666.145,75.477Z",
    transform: "translate(-627.539 -44.219)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(10.415 141.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M612.208,162.58h-3.736c-2.709,0-4.088,2.5-4.392,5.933-.031-.158.275,8.014.949,15.231a4.6,4.6,0,0,0,4.383,4.391h79.976a1.586,1.586,0,0,1,.292.027l5.8,1.12a.879.879,0,0,0,.954-1.254l-2.327-4.681a2.124,2.124,0,0,1-.217-.808c-.949-14.392-.324-9.242-.911-15.569a4.6,4.6,0,0,0-4.383-4.39Z",
    transform: "translate(-603.692 -162.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M695.65,189.693a1.277,1.277,0,0,1-.245-.023l-5.8-1.12a1.123,1.123,0,0,0-.217-.021H609.412a4.989,4.989,0,0,1-4.776-4.748c-.351-3.762-.594-7.684-.736-10.311-.157-2.914-.205-4.859-.207-4.88a.155.155,0,0,1,0-.023c.052-1.947.137-3.274,1.2-4.568a4.692,4.692,0,0,1,3.58-1.814H688.6a4.987,4.987,0,0,1,4.776,4.748c.272,2.937.285,3.428.314,4.5.033,1.249.088,3.34.6,11.075a1.744,1.744,0,0,0,.177.658l2.326,4.681a1.273,1.273,0,0,1-1.137,1.841Zm-91.177-21.137c0,.581.315,8.363.949,15.151a4.207,4.207,0,0,0,3.99,4.033h79.976a1.871,1.871,0,0,1,.366.035l5.8,1.12a.484.484,0,0,0,.525-.691l-2.326-4.681a2.552,2.552,0,0,1-.258-.958c-.511-7.751-.567-9.851-.6-11.106-.029-1.091-.041-1.542-.31-4.452a4.2,4.2,0,0,0-3.99-4.032H608.472a3.912,3.912,0,0,0-2.97,1.525,4.817,4.817,0,0,0-1.035,3.934v0A.442.442,0,0,1,604.473,168.556Z",
    transform: "translate(-603.692 -162.185)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M624.264,174.727c.028,3-1.842,6-5.7,6a6.074,6.074,0,0,1-5.92-6,5.961,5.961,0,0,1,5.92-6C622.308,168.725,624.235,171.726,624.264,174.727Z",
    transform: "translate(-603.692 -162.185)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(25.532 11.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    d: "M672.089,175.517H630.014a.79.79,0,0,1,0-1.58h42.075a.79.79,0,1,1,0,1.58Z",
    transform: "translate(-629.224 -173.937)",
    fill: "#211d52"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(0 69.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M683.338,147.8H602.451a4.468,4.468,0,0,1-4.414-4.078c-3.009-29.716-1.419-16.339-4.346-48.068a4.419,4.419,0,0,1,4.413-4.8h80.888a4.538,4.538,0,0,1,4.413,4.079c1.321,9.433,3.35,34.206,4.347,48.068A4.435,4.435,0,0,1,683.338,147.8Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    d: "M683.338,148.192H602.451a4.862,4.862,0,0,1-4.807-4.433c-1.671-16.5-1.929-19.781-2.32-24.746-.323-4.105-.725-9.213-2.027-23.326a4.785,4.785,0,0,1,1.231-3.653,4.852,4.852,0,0,1,3.576-1.58h80.888a4.939,4.939,0,0,1,4.8,4.419c1.334,9.537,3.376,34.561,4.349,48.095a4.829,4.829,0,0,1-4.808,5.224ZM598.1,91.244a4.06,4.06,0,0,0-2.992,1.322,3.937,3.937,0,0,0-1.028,3.048c1.3,14.119,1.705,19.23,2.028,23.337.39,4.96.648,8.237,2.318,24.728a4.074,4.074,0,0,0,4.021,3.723h80.887a4.04,4.04,0,0,0,4.02-4.374c-.972-13.527-3.011-38.528-4.344-48.046a4.155,4.155,0,0,0-4.022-3.738Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M674.692,105.985H618.471A2.3,2.3,0,0,1,616.226,104l-.147-1.323a1.758,1.758,0,0,1,1.8-1.984H674.1a2.3,2.3,0,0,1,2.245,1.984L676.5,104A1.759,1.759,0,0,1,674.692,105.985Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M647.4,100.694H617.882a1.758,1.758,0,0,0-1.8,1.984l.147,1.323a2.3,2.3,0,0,0,2.245,1.984h29.277Q647.7,103.337,647.4,100.694Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M606.772,99.017h-.066a3.562,3.562,0,0,0-3.62,3.887h0a4.292,4.292,0,0,0,4.222,3.887h.066a3.562,3.562,0,0,0,3.62-3.887h0A4.292,4.292,0,0,0,606.772,99.017Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M675.872,119.019H619.65a2.3,2.3,0,0,1-2.245-1.984l-.147-1.322a1.759,1.759,0,0,1,1.8-1.984h56.222a2.3,2.3,0,0,1,2.245,1.984l.147,1.322A1.759,1.759,0,0,1,675.872,119.019Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M627.162,113.729h-8.1a1.759,1.759,0,0,0-1.8,1.984l.147,1.322a2.3,2.3,0,0,0,2.245,1.984h8.042Q627.512,116.367,627.162,113.729Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    d: "M607.952,112.051h-.067a3.56,3.56,0,0,0-3.619,3.887h0a4.291,4.291,0,0,0,4.221,3.887h.066a3.561,3.561,0,0,0,3.62-3.887h0A4.291,4.291,0,0,0,607.952,112.051Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M677.051,132.054H620.829a2.3,2.3,0,0,1-2.245-1.984l-.147-1.323a1.759,1.759,0,0,1,1.8-1.984h56.221a2.3,2.3,0,0,1,2.245,1.984l.147,1.323A1.758,1.758,0,0,1,677.051,132.054Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    d: "M659.028,126.763H620.241a1.759,1.759,0,0,0-1.8,1.984l.147,1.323a2.3,2.3,0,0,0,2.245,1.984h38.635C659.373,130.287,659.237,128.522,659.028,126.763Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M609.131,125.085h-.066a3.562,3.562,0,0,0-3.62,3.887h0a4.292,4.292,0,0,0,4.221,3.888h.067a3.562,3.562,0,0,0,3.619-3.888h0A4.292,4.292,0,0,0,609.131,125.085Z",
    transform: "translate(-593.277 -90.454)",
    fill: "#628ad9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655",
    transform: "translate(134.357 146.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M773.295,168.007h-41.9c-1.564,0-2.749,1.766-2.668,3.838.112,2.87-.751-7.245,1.007,15.728a2.6,2.6,0,0,1-.18,1.168l-1.5,3.744a.269.269,0,0,0,.337.354l3.576-1.232a3.059,3.059,0,0,1,1-.168h44.264c1.565,0,2.8-1.771,2.669-3.838-.6-11.082-.693-11.589-1.053-16.334-.141-1.841-1.275-3.26-2.669-3.26Z",
    transform: "translate(-727.634 -167.612)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6704",
    "data-name": "Path 6704",
    d: "M728.295,193.25a.664.664,0,0,1-.612-.911l1.5-3.745a2.22,2.22,0,0,0,.152-.991c-.49-6.4-.795-10.477-.961-12.837-.161-2.29-.2-2.889-.051-3.067a4.641,4.641,0,0,1,1.158-3.226,2.623,2.623,0,0,1,1.909-.861h44.778c1.589,0,2.905,1.559,3.062,3.625.058.761.109,1.413.156,2.016.244,3.129.392,5.017.9,14.326a4.539,4.539,0,0,1-1.1,3.352,2.7,2.7,0,0,1-1.961.9H732.961a2.663,2.663,0,0,0-.871.146l-3.575,1.233A.673.673,0,0,1,728.295,193.25Zm.736-20.569c.092,1.58.43,6.168,1.095,14.862a3.011,3.011,0,0,1-.206,1.345l-1.4,3.488,3.314-1.143a3.464,3.464,0,0,1,1.128-.189h44.264a1.9,1.9,0,0,0,1.386-.654,3.745,3.745,0,0,0,.888-2.765c-.505-9.3-.653-11.187-.9-14.31-.048-.6-.1-1.257-.156-2.018-.126-1.65-1.1-2.9-2.275-2.9H731.394a1.852,1.852,0,0,0-1.34.619,3.882,3.882,0,0,0-.934,2.809C729.137,172.252,729.148,172.531,729.031,172.681Z",
    transform: "translate(-727.634 -167.612)",
    fill: "#628ad9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M751.235,177.132a13.163,13.163,0,0,0-2.818-.427.607.607,0,0,1-.492-.323,14.174,14.174,0,0,0-1.223-2.052.3.3,0,0,0-.521,0,21.857,21.857,0,0,0-.961,2.225.335.335,0,0,1-.3.216,15.623,15.623,0,0,0-2.437.338.237.237,0,0,0-.2.29.329.329,0,0,0,.106.245c.691.684,1.051,1.165,1.73,1.756a.424.424,0,0,1,.147.4,17.77,17.77,0,0,0-.43,2.9c.252.479.858.163,1.152-.007a19.015,19.015,0,0,0,1.814-1.218.276.276,0,0,1,.309,0c.753.469,1.48.838,2.263,1.247.437.228,1.345.663,1.257-.294a19.732,19.732,0,0,0-.844-2.308.532.532,0,0,1,.08-.556,7.789,7.789,0,0,0,1.455-2.059A.325.325,0,0,0,751.235,177.132Z",
    transform: "translate(-727.634 -167.612)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M766.308,177.132a13.178,13.178,0,0,0-2.819-.427.607.607,0,0,1-.491-.323,14.282,14.282,0,0,0-1.223-2.052.3.3,0,0,0-.522,0,21.87,21.87,0,0,0-.961,2.225.333.333,0,0,1-.3.216,15.6,15.6,0,0,0-2.436.338.238.238,0,0,0-.2.29.329.329,0,0,0,.106.245c.691.684,1.051,1.165,1.73,1.756a.425.425,0,0,1,.148.4,17.686,17.686,0,0,0-.431,2.9c.252.479.858.163,1.152-.007a19.016,19.016,0,0,0,1.814-1.218.276.276,0,0,1,.309,0c.754.469,1.48.838,2.264,1.247.436.228,1.344.663,1.257-.294a20.1,20.1,0,0,0-.844-2.308.534.534,0,0,1,.079-.556A7.768,7.768,0,0,0,766.4,177.5.326.326,0,0,0,766.308,177.132Z",
    transform: "translate(-727.634 -167.612)",
    fill: "#ffd56b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(100.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6707",
    "data-name": "Path 6707",
    d: "M808.536,21.06H701.462a7.58,7.58,0,0,0-7.568,8.234c5.02,54.408,2.293,31.47,7.453,82.426.015.147.05.351.09.562a3.819,3.819,0,0,1-.126,1.944c-.54,1.6-1.252,3.238-1.732,4.884a1.026,1.026,0,0,0,1.086,1.313c1.935-.177,7.952-1.709,8.7-1.709H820.011a7.606,7.606,0,0,0,7.569-8.234c-1.71-23.77-5.189-66.25-7.453-82.426a7.786,7.786,0,0,0-7.569-6.994Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6708",
    "data-name": "Path 6708",
    d: "M700.569,120.823A1.421,1.421,0,0,1,699.2,119c.292-1,.669-2,1.035-2.971.24-.636.488-1.293.7-1.929a3.435,3.435,0,0,0,.112-1.742c-.048-.253-.08-.454-.1-.6-2.865-28.291-3.307-33.914-3.977-42.427-.554-7.04-1.243-15.8-3.476-40a7.912,7.912,0,0,1,2.037-6.047,8.034,8.034,0,0,1,5.924-2.618h111.1A8.19,8.19,0,0,1,820.518,28c2.287,16.343,5.787,59.247,7.456,82.453a8,8,0,0,1-7.963,8.657H709.362c-.291,0-1.8.332-3.251.654-2.024.447-4.317.953-5.41,1.054Q700.635,120.823,700.569,120.823Zm.893-99.368a7.242,7.242,0,0,0-5.34,2.36,7.03,7.03,0,0,0-1.835,5.442c2.234,24.208,2.923,32.971,3.477,40.013.67,8.507,1.112,14.128,3.976,42.41.014.138.047.329.085.528a4.219,4.219,0,0,1-.14,2.144c-.218.648-.469,1.312-.711,1.955-.36.955-.733,1.942-1.016,2.914a.626.626,0,0,0,.116.581.64.64,0,0,0,.555.228c1.043-.1,3.41-.618,5.311-1.038a30.669,30.669,0,0,1,3.422-.673H820.011A7.113,7.113,0,0,0,825.3,116a7.251,7.251,0,0,0,1.889-5.489c-1.668-23.2-5.166-66.08-7.451-82.4a7.406,7.406,0,0,0-7.177-6.653Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6709",
    "data-name": "Path 6709",
    d: "M814.843,105.985H714.926a3.9,3.9,0,0,1-3.842-3.556c-2.7-25.907-.3-2.457-2.928-30.12a3.832,3.832,0,0,1,3.817-4.186H811.89a3.963,3.963,0,0,1,3.842,3.556c1.173,8.224,2.024,18.034,2.928,30.12A3.845,3.845,0,0,1,814.843,105.985Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#fad3b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6710",
    "data-name": "Path 6710",
    d: "M724.263,38.394c.039,4.053-2.529,8.107-7.821,8.107a8.272,8.272,0,0,1-8.13-8.107,8.117,8.117,0,0,1,8.129-8.106C721.577,30.288,724.224,34.341,724.263,38.394Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657",
    transform: "translate(23.818 58.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6711",
    "data-name": "Path 6711",
    d: "M804.155,80.014H717.681a.4.4,0,1,1,0-.79h86.474a.4.4,0,0,1,0,.79Z",
    transform: "translate(-717.286 -79.224)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658",
    transform: "translate(25.084 66.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6712",
    "data-name": "Path 6712",
    d: "M768.056,88.064H718.947a.4.4,0,1,1,0-.79h49.109a.4.4,0,0,1,0,.79Z",
    transform: "translate(-718.552 -87.274)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659",
    transform: "translate(37.359 17.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6713",
    "data-name": "Path 6713",
    d: "M782.216,39.879h-50.6a.79.79,0,1,1,0-1.579h50.6a.79.79,0,0,1,0,1.579Z",
    transform: "translate(-730.827 -38.3)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6714",
    "data-name": "Path 6714",
    d: "M719.769,54.947a15.5,15.5,0,0,0-3.341-.506.72.72,0,0,1-.583-.383,16.72,16.72,0,0,0-1.45-2.433.354.354,0,0,0-.618.005,26.106,26.106,0,0,0-1.14,2.638.4.4,0,0,1-.352.256,18.565,18.565,0,0,0-2.888.4.282.282,0,0,0-.234.344.389.389,0,0,0,.126.291c.818.811,1.245,1.381,2.05,2.081a.5.5,0,0,1,.175.47,21,21,0,0,0-.51,3.438c.3.568,1.017.194,1.365-.008A22.554,22.554,0,0,0,714.52,60.1a.327.327,0,0,1,.367,0c.893.555,1.754.993,2.683,1.478.517.27,1.594.786,1.49-.349a23.59,23.59,0,0,0-1-2.736.632.632,0,0,1,.094-.659,9.233,9.233,0,0,0,1.725-2.441A.385.385,0,0,0,719.769,54.947Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    d: "M734.584,54.947a15.513,15.513,0,0,0-3.342-.506.722.722,0,0,1-.583-.383,16.7,16.7,0,0,0-1.45-2.433.354.354,0,0,0-.618.005,25.865,25.865,0,0,0-1.139,2.638.4.4,0,0,1-.352.256,18.575,18.575,0,0,0-2.889.4.282.282,0,0,0-.234.344.389.389,0,0,0,.126.291c.819.811,1.245,1.381,2.05,2.081a.505.505,0,0,1,.176.47,21.044,21.044,0,0,0-.511,3.438c.3.568,1.018.194,1.366-.008a22.818,22.818,0,0,0,2.151-1.444.325.325,0,0,1,.366,0c.893.555,1.754.993,2.683,1.478.518.27,1.594.786,1.491-.349a23.626,23.626,0,0,0-1-2.736.632.632,0,0,1,.094-.659,9.211,9.211,0,0,0,1.725-2.441A.387.387,0,0,0,734.584,54.947Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6716",
    "data-name": "Path 6716",
    d: "M748.657,54.947a15.526,15.526,0,0,0-3.342-.506.721.721,0,0,1-.583-.383,16.7,16.7,0,0,0-1.45-2.433.354.354,0,0,0-.618.005,25.863,25.863,0,0,0-1.139,2.638.4.4,0,0,1-.352.256,18.574,18.574,0,0,0-2.889.4.282.282,0,0,0-.234.344.389.389,0,0,0,.126.291c.818.811,1.245,1.381,2.05,2.081a.5.5,0,0,1,.175.47,21.121,21.121,0,0,0-.51,3.438c.3.568,1.018.194,1.366-.008a22.663,22.663,0,0,0,2.15-1.444.327.327,0,0,1,.367,0c.893.555,1.754.993,2.683,1.478.517.27,1.594.786,1.491-.349a23.829,23.829,0,0,0-1-2.736.632.632,0,0,1,.094-.659,9.211,9.211,0,0,0,1.725-2.441A.387.387,0,0,0,748.657,54.947Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6717",
    "data-name": "Path 6717",
    d: "M763.268,54.947a15.525,15.525,0,0,0-3.342-.506.721.721,0,0,1-.583-.383,16.724,16.724,0,0,0-1.45-2.433.354.354,0,0,0-.618.005,25.878,25.878,0,0,0-1.139,2.638.4.4,0,0,1-.352.256,18.575,18.575,0,0,0-2.889.4.282.282,0,0,0-.234.344.389.389,0,0,0,.126.291c.818.811,1.245,1.381,2.05,2.081a.5.5,0,0,1,.175.47,21.1,21.1,0,0,0-.51,3.438c.3.568,1.018.194,1.366-.008a22.647,22.647,0,0,0,2.15-1.444.327.327,0,0,1,.367,0c.893.555,1.754.993,2.683,1.478.517.27,1.594.786,1.491-.349a23.82,23.82,0,0,0-1-2.736.632.632,0,0,1,.094-.659,9.21,9.21,0,0,0,1.725-2.441A.386.386,0,0,0,763.268,54.947Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6718",
    "data-name": "Path 6718",
    d: "M777.782,54.947a15.525,15.525,0,0,0-3.342-.506.721.721,0,0,1-.583-.383,16.711,16.711,0,0,0-1.45-2.433.354.354,0,0,0-.618.005,26.107,26.107,0,0,0-1.14,2.638.4.4,0,0,1-.351.256,18.577,18.577,0,0,0-2.889.4.282.282,0,0,0-.234.344.389.389,0,0,0,.126.291c.818.811,1.245,1.381,2.05,2.081a.5.5,0,0,1,.175.47,21.012,21.012,0,0,0-.51,3.438c.3.568,1.018.194,1.366-.008a22.645,22.645,0,0,0,2.15-1.444.327.327,0,0,1,.367,0c.893.555,1.754.993,2.683,1.478.517.27,1.594.786,1.491-.349a23.825,23.825,0,0,0-1-2.736.632.632,0,0,1,.094-.659,9.215,9.215,0,0,0,1.725-2.441A.386.386,0,0,0,777.782,54.947Z",
    transform: "translate(-693.468 -20.665)",
    fill: "#ffd56b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663",
    transform: "translate(119.492 107.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6719",
    "data-name": "Path 6719",
    d: "M797.206,128.7h-78.9a4.561,4.561,0,0,0-4.3,5.364c-.03-.141,1.013,12.3,1.676,18.9a.969.969,0,0,1-.106.547l-2.382,4.574a.237.237,0,0,0,.252.342l6.34-1.166a2.453,2.453,0,0,1,.444-.04h81.778a4.316,4.316,0,0,0,4.3-4.673c-.97-13.489-1.114-14.106-1.7-19.882a4.345,4.345,0,0,0-4.295-3.969Z",
    transform: "translate(-712.77 -128.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6720",
    "data-name": "Path 6720",
    d: "M713.4,158.829a.632.632,0,0,1-.559-.924l2.382-4.573a.572.572,0,0,0,.063-.326c-.373-3.716-.844-9.062-1.092-11.919-.17-1.952-.318-3.7-.423-4.959-.082-.987-.13-1.567-.133-1.913a.367.367,0,0,1-.021-.068,4.789,4.789,0,0,1,1.025-4.01,4.74,4.74,0,0,1,3.666-1.832h82A4.74,4.74,0,0,1,805,132.63c.093.924.175,1.716.251,2.45.393,3.809.63,6.107,1.445,17.443a4.711,4.711,0,0,1-4.689,5.1H720.228a2.1,2.1,0,0,0-.372.034l-6.341,1.167A.636.636,0,0,1,713.4,158.829Zm1-24.757c.034.56,1.025,12.387,1.674,18.856a1.358,1.358,0,0,1-.149.768l-2.232,4.287,6.021-1.107a2.768,2.768,0,0,1,.515-.047h81.778a3.923,3.923,0,0,0,3.9-4.246c-.815-11.327-1.052-13.621-1.444-17.422-.076-.734-.158-1.527-.251-2.453a3.953,3.953,0,0,0-3.9-3.613h-82a3.956,3.956,0,0,0-3.052,1.539,4,4,0,0,0-.867,3.346v0A.384.384,0,0,1,714.4,134.072Zm-.76.07-.021,0Z",
    transform: "translate(-712.77 -128.305)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    "data-name": "Path 6721",
    d: "M735.75,141.284c.028,3-1.842,6-5.7,6a6.075,6.075,0,0,1-5.92-6,5.963,5.963,0,0,1,5.92-6C733.794,135.282,735.721,138.283,735.75,141.284Z",
    transform: "translate(-712.77 -128.305)",
    fill: "#fc6f56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662",
    transform: "translate(28.256 11.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6722",
    "data-name": "Path 6722",
    d: "M791.829,141.493H741.816a.79.79,0,0,1,0-1.58h50.013a.79.79,0,1,1,0,1.58Z",
    transform: "translate(-741.026 -139.913)",
    fill: "#211d52"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677",
    transform: "translate(816.849 22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    "data-name": "Path 6723",
    d: "M867.858,238.957l-7.295-.281-1.313-9.013,7.348-1.1Z",
    transform: "translate(-821.045 -22)",
    fill: "#44484f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6724",
    "data-name": "Path 6724",
    d: "M862.024,243.84c3.822,1.214,12.449-7.181,14.1-8.75,0,0,2.126,2.1,7.348-.042,3.646,1.813,3.406,10.208,3.195,13.241a1.259,1.259,0,0,1-1.16,1.174l-6.689.481a.885.885,0,0,1-.94-.828l-.05-.726-6.774,2.383c-6.774,2.383-14.608-.845-14.608-.845l-.056-2.7C856.329,244.52,858.2,242.625,862.024,243.84Z",
    transform: "translate(-837.129 -22)",
    fill: "#231919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6725",
    "data-name": "Path 6725",
    d: "M867.871,231.983a15.3,15.3,0,0,1-7.383.288l-.381-2.608,7.348-1.1Z",
    transform: "translate(-821.903 -22)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6726",
    "data-name": "Path 6726",
    d: "M871.471,243.84c3.158,1,9.594-4.552,12.665-7.4,6.424,4.462.414,10.74-5.683,11.507a28.149,28.149,0,0,1-12.612-.994C865.912,244.4,867.779,242.666,871.471,243.84Z",
    transform: "translate(-846.576 -22)",
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665",
    transform: "translate(29.045 127.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    d: "M870.659,153.869c-.044.182-1.109,23.511,6.309,74.372a1.433,1.433,0,0,1-1.1,1.754l-10.665.992a1.894,1.894,0,0,1-2.1-1.433c-7.831-50.685-5.672-76.762-5.533-80.1Z",
    transform: "translate(-857.196 -149.456)",
    fill: "#2b2727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6728",
    "data-name": "Path 6728",
    d: "M836.133,239.373l-7.294-.281-1.314-9.013,7.348-1.1Z",
    transform: "translate(-758.049 -22)",
    fill: "#44484f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    d: "M836.147,231.319c-2.932,1.354-5.354,1.526-7.313.952l-.319-2.192,7.348-1.1Z",
    transform: "translate(-759.039 -22)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666",
    transform: "translate(53.031 123.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6730",
    "data-name": "Path 6730",
    d: "M839.238,145.714c-.044.183-1.653,37.865,13.235,82.316a1.42,1.42,0,0,1-1.158,1.894l-11.077,1.155a1.714,1.714,0,0,1-1.792-1.157c-18.545-53.85-11.691-80.19-11.1-82.295Z",
    transform: "translate(-825.624 -145.714)",
    fill: "#2b2727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667",
    transform: "translate(29.047 127.456)",
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6731",
    "data-name": "Path 6731",
    d: "M877.076,170.092q-2.864-.247-5.7-.647a57.562,57.562,0,0,1-7.964-1.721c-.2-10.734.261-16.778.323-18.268l13.087,4.412C876.8,153.955,876.551,159.211,877.076,170.092Z",
    transform: "translate(-863.359 -149.456)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(53.032 123.714)",
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6732",
    "data-name": "Path 6732",
    d: "M852.732,168.271a46.77,46.77,0,0,1-5.327,1.223,68.274,68.274,0,0,1-8.981.89c-.667-14.238,1.277-21.679,1.577-22.757l11.9-1.913A180.424,180.424,0,0,0,852.732,168.271Z",
    transform: "translate(-838.286 -145.714)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6733",
    "data-name": "Path 6733",
    d: "M830.3,244.256c3.822,1.215,12.45-7.18,14.1-8.749,0,0,2.127,2.1,7.348-.043,3.563,1.772,3.415,9.826,3.209,13.024a1.5,1.5,0,0,1-1.376,1.406l-6.107.439a1.267,1.267,0,0,1-1.347-1.185l-.024-.341-6.773,2.383c-6.774,2.383-14.607-.845-14.607-.845l-.057-2.705C824.605,244.937,826.477,243.042,830.3,244.256Z",
    transform: "translate(-774.133 -22)",
    fill: "#231919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6734",
    "data-name": "Path 6734",
    d: "M847.931,242.841c-1.064,2.086-3.424,3.227-5.594,3.647a11.562,11.562,0,0,1-9.271-2.131c3.463-.335,9-5.2,11.657-7.673C846.932,238.036,849.281,240.193,847.931,242.841Z",
    transform: "translate(-775.706 -22)",
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6735",
    "data-name": "Path 6735",
    d: "M866.724,81.1c.474-3.357.9-6.719,1.148-10.1-6.034-1.341-15.678-.788-18.187-.57a54.389,54.389,0,0,0-7.563,1.128c.508,2.448.508,4.982.978,7.458C851.011,79.068,858.857,80.232,866.724,81.1Z",
    transform: "translate(-804.177 -22)",
    fill: "#eb937f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6736",
    "data-name": "Path 6736",
    d: "M848.681,113.769q-6.647.531-13.286,1.137c.191-14.376,1.392-26.331.842-32.037-.4-4.176,3.2-9.816,7.2-10.89a31.568,31.568,0,0,1,4.816-.861c.6,4.122,4.881,7.809,8.941,7.093,4.415-.779,6.116-3.756,6.49-8.052,5.889-.1,9.083,2.585,13.165,4.184,1.294,1.41,1.711,18.141,1.621,37.3C868.519,112.159,858.569,112.98,848.681,113.769Z",
    transform: "translate(-808.15 -22)",
    fill: "#a4d4e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6737",
    "data-name": "Path 6737",
    d: "M867.344,78.407a1.313,1.313,0,0,0-1.331,1.127c-1,6.67-8.011,39.949-7.765,42.949.273,3.335,5,6.1,5,6.1s4.621-2.822,5.246-6.62c.565-3.441.335-36.358-.1-42.536a1.089,1.089,0,0,0-1.056-1.021Z",
    transform: "translate(-821.024 -22)",
    fill: "#4f1e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6738",
    "data-name": "Path 6738",
    d: "M858.993,116.056a3.441,3.441,0,0,0,3.225-.693,53.718,53.718,0,0,1,.011,6.6c-.389,2.367-2.33,4.354-3.738,5.516C858.669,126.337,858.854,121.831,858.993,116.056Z",
    transform: "translate(-814.756 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6739",
    "data-name": "Path 6739",
    d: "M858.39,57.131l1.006,0c2.175.005,3.571,2.389,3.566,4.6L862.82,74c0,2.206-1.294,2.7-3.47,2.691l-1.007,0c-2.174-.006-4.052-1.4-4.047-3.6l.129-11.948A4,4,0,0,1,858.39,57.131Z",
    transform: "translate(-811.265 -22)",
    fill: "#ff9f85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6740",
    "data-name": "Path 6740",
    d: "M858.332,57.131l1.006,0c2.175.005,3.571,2.389,3.566,4.6l-.075,6.431c-2.762,1.319-5.676.8-8.534-.38l.072-6.647A4,4,0,0,1,858.332,57.131Z",
    transform: "translate(-811.208 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6741",
    "data-name": "Path 6741",
    d: "M841.746,47.642s-4.849-2.375-3.47-9.564c1.03-5.369,3.845-7.552,3.845-7.552a4.021,4.021,0,0,1,.181-5.132c2.242-2.511,4.836.956,4.836.956s3.3-5.232,14.7-1.423c9,3.006,8.516,6.012,8.516,6.012s3.682-3.234,5.747.944c2.16,4.37-1.027,5.346-1.027,5.346a8.21,8.21,0,0,1,1.072,10.035C873.576,51.674,841.746,47.642,841.746,47.642Z",
    transform: "translate(-809.68 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6742",
    "data-name": "Path 6742",
    d: "M840.344,46.218c.071-.014.142-.006.213-.013l-.108-2.97A13.331,13.331,0,0,1,853.13,29.381l5.5-.206A13.3,13.3,0,0,1,872.284,42.04l.1,2.624a2.476,2.476,0,0,1,1.9-.344c1.593.407,2.446,2.5,1.907,4.673-.5,2.028-2.04,3.391-3.539,3.237a13.325,13.325,0,0,1-12.68,13.741l-5.5.206c-6.958.262-16.088-4.121-13.581-12.009a4.143,4.143,0,0,1-2.7-3.363C837.763,48.6,838.725,46.543,840.344,46.218Z",
    transform: "translate(-808.68 -22)",
    fill: "#ff9f85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6743",
    "data-name": "Path 6743",
    d: "M844.141,28.086l.006-.063C844.27,28.119,844.279,28.148,844.141,28.086Z",
    transform: "translate(-782.535 -22)",
    fill: "#784c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6744",
    "data-name": "Path 6744",
    d: "M838.554,38.078c1.03-5.369,3.845-7.552,3.845-7.552a4.021,4.021,0,0,1,.181-5.132c2.242-2.511,4.836.956,4.836.956s2.535-5.111,13.935-1.3c9,3.007,9.284,5.892,9.284,5.892s3.682-3.234,5.747.944c2.16,4.37-1.027,5.346-1.027,5.346a8.691,8.691,0,0,1,2.066,3.691c-3.21,1.548-4.145,4.666-4.815,7.967-.723.117-1.533.206-2.4.273-.217-6.411-1.57-14.8-3.005-15.085-18.783-6.986-26.145-.678-25.372,12.13C840.364,45.3,837.417,44.006,838.554,38.078Z",
    transform: "translate(-809.957 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6745",
    "data-name": "Path 6745",
    d: "M845.068,46.2l-.059-.036a19.712,19.712,0,0,1,3.326-15.729c3.184-.811,12.824-5.289,25.483,3.213,1.122,4.734.664,10.58-.064,15.478-.1.009-.2.021-.308.029-.217-6.411-1.57-14.8-3.005-15.085C851.657,27.089,844.3,33.4,845.068,46.2Z",
    transform: "translate(-813.192 -22)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6746",
    "data-name": "Path 6746",
    d: "M842.046,27.406a3.542,3.542,0,0,0,2.947,4.017,3.5,3.5,0,0,0,4.218-2.6,3.542,3.542,0,0,0-2.947-4.017A3.5,3.5,0,0,0,842.046,27.406Z",
    transform: "translate(-785.44 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6747",
    "data-name": "Path 6747",
    d: "M863.656,25.141a2.959,2.959,0,0,0,2.369,3.428,2.92,2.92,0,0,0,3.464-2.276,2.957,2.957,0,0,0-2.369-3.427A2.92,2.92,0,0,0,863.656,25.141Z",
    transform: "translate(-827.018 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6748",
    "data-name": "Path 6748",
    d: "M872.388,29.97a2.713,2.713,0,0,0,1.829,3.321,2.678,2.678,0,0,0,2.924-2.381,2.714,2.714,0,0,0-1.829-3.321A2.678,2.678,0,0,0,872.388,29.97Z",
    transform: "translate(-843.279 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6749",
    "data-name": "Path 6749",
    d: "M846.666,24.752c-.329,1.712,1.523,3.519,4.136,4.035s5-.453,5.327-2.165-1.523-3.519-4.136-4.035S846.994,23.04,846.666,24.752Z",
    transform: "translate(-796.91 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6750",
    "data-name": "Path 6750",
    d: "M864.764,26.1c.318-1.658-1.58-3.429-4.24-3.955s-5.075.393-5.394,2.051,1.58,3.429,4.24,3.955S864.446,27.762,864.764,26.1Z",
    transform: "translate(-813.891 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6751",
    "data-name": "Path 6751",
    d: "M875.027,35.916c-.371,1.932.186,3.668,1.245,3.877s2.217-1.187,2.587-3.12S878.674,33,877.615,32.8,875.4,33.984,875.027,35.916Z",
    transform: "translate(-847.598 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6752",
    "data-name": "Path 6752",
    d: "M875.483,42.855c.4,1.327,1.435,2.184,2.322,1.912s1.286-1.569.891-2.9-1.434-2.184-2.322-1.913S875.089,41.527,875.483,42.855Z",
    transform: "translate(-847.886 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6753",
    "data-name": "Path 6753",
    d: "M838.367,37.88a1.982,1.982,0,0,0,1.666,2.233,1.956,1.956,0,0,0,2.371-1.436,1.982,1.982,0,0,0-1.666-2.233A1.957,1.957,0,0,0,838.367,37.88Z",
    transform: "translate(-775.007 -22)",
    fill: "#3d1208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6754",
    "data-name": "Path 6754",
    d: "M867.082,53.773l-12.733.157a1.124,1.124,0,0,0-.963,1.567,7.571,7.571,0,0,0,7.367,4.991,7.7,7.7,0,0,0,7.3-5.171A1.1,1.1,0,0,0,867.082,53.773Z",
    transform: "translate(-815.458 -22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6755",
    "data-name": "Path 6755",
    d: "M859.964,36.915c.328,1.652,2.841,2.532,5.611,1.965s4.75-2.364,4.423-4.015-2.84-2.532-5.61-1.966S859.637,35.263,859.964,36.915Z",
    transform: "translate(-823.889 -22)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669",
    transform: "translate(35.689 23.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6756",
    "data-name": "Path 6756",
    d: "M868.778,45.6c-.992-.04-1.836.982-1.887,2.283a1.863,1.863,0,1,0,3.59.143A2.138,2.138,0,0,0,868.778,45.6Z",
    transform: "translate(-866.889 -45.595)",
    fill: "#471408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6757",
    "data-name": "Path 6757",
    d: "M853.434,45.7c-.992-.04-1.835.982-1.887,2.282a2.137,2.137,0,0,0,1.7,2.426c.991.04,1.835-.982,1.886-2.282A2.136,2.136,0,0,0,853.434,45.7Z",
    transform: "translate(-836.419 -45.595)",
    fill: "#471408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6758",
    "data-name": "Path 6758",
    d: "M867.173,47.879a2.138,2.138,0,0,0,1.7,2.426,1.786,1.786,0,0,0,1.612-1.159c-.836-1.042-1.676-2.08-2.544-3.092A2.652,2.652,0,0,0,867.173,47.879Z",
    transform: "translate(-867.171 -45.595)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M851.849,47.984a2.136,2.136,0,0,0,1.7,2.426,1.766,1.766,0,0,0,1.59-1.109c-.872-1.018-1.724-2.053-2.544-3.114A2.655,2.655,0,0,0,851.849,47.984Z",
    transform: "translate(-836.722 -45.595)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6760",
    "data-name": "Path 6760",
    d: "M849.513,71.118s-.528,7.1,2.126,10.2c0,0,1.291-3.431,4.323-2.909a5.577,5.577,0,0,1,4.046,3.51s6.5-4.259,5.807-9.772Z",
    transform: "translate(-809.414 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6761",
    "data-name": "Path 6761",
    d: "M857.31,73.314s4.412-1.02,5.616,1.664-2.322,5.016-2.322,5.016a3.694,3.694,0,0,1-4.509-3.015C855.182,73.1,857.31,73.314,857.31,73.314Z",
    transform: "translate(-813.029 -22)",
    fill: "#4f1e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6762",
    "data-name": "Path 6762",
    d: "M861.749,78.759V78.7a3.158,3.158,0,0,0-2.809-3.337,3.078,3.078,0,0,0-2.226.734,3.19,3.19,0,0,0-.642.789c-.856-3.783,1.233-3.573,1.233-3.573s4.412-1.02,5.616,1.664c.731,1.629-.281,3.125-1.189,4.053,0-.021-.006-.041-.006-.061C861.737,78.9,861.747,78.828,861.749,78.759Z",
    transform: "translate(-813.026 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    d: "M849.526,71.118a9.35,9.35,0,0,1,2.989-2.47s-.034,2.628,3.7,2.647a5.037,5.037,0,0,0,4.836-3.135,14.79,14.79,0,0,1,3.908,2c1.917,1.394.936,6.775-5.753,9.494,0,0-1.41-5.686-3.136-5.9s-3.692,5.715-3.692,5.715A15.5,15.5,0,0,1,849.526,71.118Z",
    transform: "translate(-809.427 -22)",
    fill: "#a4d4e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6764",
    "data-name": "Path 6764",
    d: "M842.314,71.979a31.57,31.57,0,0,1,4.816-.861c.15,1.025,2.047,13.262,5.5,28.355,4.8-12.432,7.09-17.342,11.313-29.317,5.155.049,12.365,1.569,15.072,4.985,2.581,4.577-1.53,53.907-1.658,83.463-5.7,4.243-42.366,3.219-42.931-1.1-2.019-15.436-2.038-61.272-.4-76.5C834.672,74.981,838.316,73.053,842.314,71.979Z",
    transform: "translate(-807.031 -22)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6765",
    "data-name": "Path 6765",
    d: "M848.359,132.227l-13.714-.626v1.81l13.672-.189Z",
    transform: "translate(-777.293 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6766",
    "data-name": "Path 6766",
    d: "M869.691,132.075l10.539-.475v1.81l-10.514-.144C869.707,132.873,869.7,132.472,869.691,132.075Z",
    transform: "translate(-843.707 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    d: "M860.1,81.007c.648-6.026,4.292-7.954,8.289-9.028a31.57,31.57,0,0,1,4.816-.861c.15,1.025,2.047,13.262,5.5,28.355.587-1.523,1.674,57.732,1.523,61.8-10.019-.254-19.442-1.592-19.727-3.765C858.479,142.068,858.459,96.232,860.1,81.007Z",
    transform: "translate(-833.101 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2588",
    "data-name": "Rectangle 2588",
    width: 8.752,
    height: 5.777,
    rx: 0.538,
    transform: "translate(62.236 77.518) rotate(-178.499)",
    fill: "#355b59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2589",
    "data-name": "Rectangle 2589",
    width: 7.671,
    height: 4.622,
    rx: 0.428,
    transform: "translate(61.711 76.926) rotate(-178.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2590",
    "data-name": "Rectangle 2590",
    width: 2.282,
    height: 3.216,
    transform: "translate(61.195 75.977) rotate(-178.502)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2591",
    "data-name": "Rectangle 2591",
    d: "M.15,0H3.456a.151.151,0,0,1,.151.151V.268a.151.151,0,0,1-.151.151H.151A.151.151,0,0,1,0,.268V.15A.15.15,0,0,1,.15,0Z",
    transform: "translate(58.234 73.216) rotate(-178.498)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2592",
    "data-name": "Rectangle 2592",
    d: "M.15,0H3.456a.151.151,0,0,1,.151.151V.268a.151.151,0,0,1-.151.151H.151A.151.151,0,0,1,0,.268V.15A.15.15,0,0,1,.15,0Z",
    transform: "translate(58.216 73.915) rotate(-178.498)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2593",
    "data-name": "Rectangle 2593",
    d: "M.151,0H3.456a.151.151,0,0,1,.151.151V.268a.15.15,0,0,1-.15.15H.151A.151.151,0,0,1,0,.268V.151A.151.151,0,0,1,.151,0Z",
    transform: "translate(58.198 74.614) rotate(-178.498)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2594",
    "data-name": "Rectangle 2594",
    d: "M.151,0H3.456a.151.151,0,0,1,.151.151V.268a.151.151,0,0,1-.151.151H.15A.15.15,0,0,1,0,.268V.151A.151.151,0,0,1,.151,0Z",
    transform: "translate(58.18 75.313) rotate(-178.498)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2595",
    "data-name": "Rectangle 2595",
    width: 3.607,
    height: 0.418,
    rx: 0.151,
    transform: "translate(58.162 76.013) rotate(-178.498)",
    fill: "#c3dbd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2596",
    "data-name": "Rectangle 2596",
    width: 0.758,
    height: 1.491,
    rx: 0.276,
    transform: "matrix(-1, -0.027, 0.027, -1, 58.539, 72.037)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6768",
    "data-name": "Path 6768",
    d: "M843.442,99.472c4.8-12.431,7.09-17.341,11.313-29.316a32.957,32.957,0,0,1,5.5.54,37.352,37.352,0,0,1-2.932,14.975,19.728,19.728,0,0,0-5.481-.086,50.033,50.033,0,0,1,4.917,1.807,49.344,49.344,0,0,1-12.967,16.273c.04-1.525-.4-2.678-.36-4.252Z",
    transform: "translate(-797.842 -22)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6769",
    "data-name": "Path 6769",
    d: "M866.271,84.009a13.559,13.559,0,0,0-4.666.37,58.916,58.916,0,0,1-1.479-12.361,31.357,31.357,0,0,1,4.957-.9c.143.98,2.328,14.175,5.5,28.355a39.118,39.118,0,0,1,.346,4.192,51.207,51.207,0,0,1-5.635-8.474,52.351,52.351,0,0,1-3.313-9.29A17.054,17.054,0,0,1,866.271,84.009Z",
    transform: "translate(-824.983 -22)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(62.983 97.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6770",
    "data-name": "Path 6770",
    d: "M835.945,128.343s5.421,3.052,5.974,1.527-4.909-4.022-4.909-4.022Z",
    transform: "translate(-835.157 -119.319)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    d: "M837.047,133.4s3.978,2.666,5.241,1.229-3.894-3.3-3.894-3.3Z",
    transform: "translate(-836.771 -119.319)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    "data-name": "Path 6772",
    d: "M836,137.5s3.347,1.006,4.69.166.146-3.618-2.117-3.014A3.6,3.6,0,0,0,836,137.5Z",
    transform: "translate(-834.512 -119.319)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    d: "M836.386,123.408a4.221,4.221,0,0,0-.953-1.028,14.436,14.436,0,0,0-2.542-1.416c-2.695-1.313-5.621-1.809-5.77-1.6l-.922,1.543-1.976,15.807c.644-.053,1.714-.108,2.2-.212a16.942,16.942,0,0,0,6.3-1.995,9.2,9.2,0,0,0,4.028-4.935C837.349,127.646,837.535,125.16,836.386,123.408Z",
    transform: "translate(-818.869 -119.319)",
    fill: "#fba386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    "data-name": "Path 6774",
    d: "M833.178,137.256s5.1-1.168,5.262.421-5.714,2.981-6.457,2.345C831.414,139.535,833.178,137.256,833.178,137.256Z",
    transform: "translate(-827.624 -119.319)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    "data-name": "Path 6775",
    d: "M842.006,120.274s-9.862,4.847-8.914,7.272,4.257-.73,4.257-.73-5.674,5.023-4.1,6.581,6.129-4.381,6.129-4.381-7.652,7.124-4.913,8.489,5.414-4.581,5.414-4.581-4.652,6.07-2.547,7.1,5.373-5.655,5.373-5.655Z",
    transform: "translate(-832.973 -119.319)",
    fill: "#fba386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(65.979 50.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6776",
    "data-name": "Path 6776",
    d: "M819.544,127.851l-5.268-5.906c-.558-.291,12.794-11.429,17.6-20.735.634-1.225-1.584-4.941-11.389-12.685a50.634,50.634,0,0,0-14.266-7.889l3.313-7.784a69.1,69.1,0,0,1,16.25,9.2c4.254,3.36,17.2,13.583,12.54,22.594C832.883,115.173,820.1,127.352,819.544,127.851Z",
    transform: "translate(-806.225 -72.852)",
    fill: "#fda688"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    "data-name": "Path 6777",
    d: "M829.378,122.164l-2.592,2.793a1.135,1.135,0,0,1-1.663.008l-5.314-5.618a.964.964,0,0,1,.091-1.407l3.949-3.2Z",
    transform: "translate(-743.43 -22)",
    fill: "#a4d4e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672",
    transform: "translate(65.521 50.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6778",
    "data-name": "Path 6778",
    d: "M824.1,123.628c-2.013-1.891-5.215-4.945-7.177-6.888a1.582,1.582,0,0,1,0-2.242c3.926-3.908,8.3-8.385,10.936-13.481.634-1.226-.3-3.423-10.109-11.167a70.643,70.643,0,0,0-13.429-8.426l2.328-9.388c.338.193,10.831,3.575,18.358,9.519,4.254,3.36,18.924,13.676,13.609,23.8a105.523,105.523,0,0,1-12.27,18.164A1.553,1.553,0,0,1,824.1,123.628Z",
    transform: "translate(-804.315 -72.036)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673",
    transform: "translate(16.519 96.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    "data-name": "Path 6779",
    d: "M878.175,128.343s-5.42,3.052-5.974,1.527,4.909-4.022,4.909-4.022Z",
    transform: "translate(-860.608 -118.848)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6780",
    "data-name": "Path 6780",
    d: "M877.081,133.4s-3.977,2.666-5.24,1.229,3.893-3.3,3.893-3.3Z",
    transform: "translate(-859 -118.848)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    "data-name": "Path 6781",
    d: "M878.128,137.5s-3.348,1.006-4.691.166-.146-3.618,2.118-3.014A3.6,3.6,0,0,1,878.128,137.5Z",
    transform: "translate(-861.262 -118.848)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    "data-name": "Path 6782",
    d: "M877.634,123.408a4.2,4.2,0,0,1,.952-1.028,14.438,14.438,0,0,1,2.542-1.416c2.7-1.313,4.822-2.3,4.97-2.087l1.26,2.038,2.439,15.8c-.644-.053-1.714-.108-2.2-.212a16.933,16.933,0,0,1-6.3-1.995,9.2,9.2,0,0,1-4.029-4.935C876.67,127.646,876.484,125.16,877.634,123.408Z",
    transform: "translate(-876.794 -118.848)",
    fill: "#fba386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    "data-name": "Path 6783",
    d: "M880.934,137.256s-5.1-1.168-5.262.421,5.715,2.981,6.458,2.345C882.7,139.535,880.934,137.256,880.934,137.256Z",
    transform: "translate(-868.131 -118.848)",
    fill: "#e38f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    "data-name": "Path 6784",
    d: "M872.061,120.274s9.862,4.847,8.913,7.272-4.256-.73-4.256-.73,5.672,5.023,4.1,6.581-6.129-4.381-6.129-4.381,7.652,7.124,4.914,8.489-5.415-4.581-5.415-4.581,4.652,6.07,2.548,7.1-5.374-5.655-5.374-5.655Z",
    transform: "translate(-862.737 -118.848)",
    fill: "#fba386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(1.498 51.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    "data-name": "Path 6785",
    d: "M891.425,128.54l5.268-5.9c-.868.454-13.178-12.175-17.6-20.735-.634-1.225,1.583-4.942,11.388-12.686a50.71,50.71,0,0,1,14.267-7.889l-3.314-7.783a69.086,69.086,0,0,0-16.249,9.2c-4.254,3.359-17.2,13.583-12.541,22.593C878.085,115.863,890.864,128.042,891.425,128.54Z",
    transform: "translate(-871.643 -73.542)",
    fill: "#fba386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675",
    transform: "translate(0 50.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M882.687,101.017a60.1,60.1,0,0,0,8.6,12.619,1.868,1.868,0,0,1-.171,2.692l-.159.132c-2.16,1.805-4.8,4.568-7.035,6.689a1.241,1.241,0,0,1-1.829-.131,110.3,110.3,0,0,1-10.474-16.474c-5.314-10.125,9.669-21.629,13.924-24.989,7.527-5.944,18.142-8.835,18.48-9.028l2.206,8.9A70.62,70.62,0,0,0,892.8,89.85C882.992,97.594,882.053,99.791,882.687,101.017Z",
    transform: "translate(-870.489 -72.527)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676",
    transform: "translate(0 50.527)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M882.687,101.017a60.1,60.1,0,0,0,8.6,12.619,1.868,1.868,0,0,1-.171,2.692l-.159.132c-2.16,1.805-4.8,4.568-7.035,6.689a1.241,1.241,0,0,1-1.829-.131,110.3,110.3,0,0,1-10.474-16.474c-5.314-10.125,9.669-21.629,13.924-24.989,7.527-5.944,18.142-8.835,18.48-9.028l2.206,8.9A70.62,70.62,0,0,0,892.8,89.85C882.992,97.594,882.053,99.791,882.687,101.017Z",
    transform: "translate(-870.489 -72.527)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M855.749,113.324a1.392,1.392,0,1,0,1.392-1.411A1.4,1.4,0,0,0,855.749,113.324Z",
    transform: "translate(-808.268 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M855.749,124.357a1.392,1.392,0,1,0,1.392-1.412A1.4,1.4,0,0,0,855.749,124.357Z",
    transform: "translate(-808.268 -22)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    "data-name": "Path 6790",
    d: "M855.749,137.458a1.392,1.392,0,1,0,1.392-1.411A1.4,1.4,0,0,0,855.749,137.458Z",
    transform: "translate(-808.268 -22)",
    opacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705",
    transform: "translate(534.476 29.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6920",
    "data-name": "Path 6920",
    d: "M322.23,319.292s2.991-3.213,6.328-1.966c4.828,1.8,25.246,11.274,20.176,33.16-5.341,23.054-21.927,17.16-21.927,17.16s-19.982,1.129-19.967-21.13S318.188,317.576,322.23,319.292Z",
    transform: "translate(-306.755 -316.167)",
    fill: "#23110d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700",
    transform: "translate(31.094 48.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    d: "M303.988,360.669c2-.324,15.792,15.482,14.862,21.626a5.333,5.333,0,0,1-2.411,3.415,8.1,8.1,0,0,1-2.412.984c-.056-.118-.107-.235-.162-.353-.156-.33-.357-.688-.568-1.064l-.01-.021c-.346-1.039-.583-2.144-.938-3.186.5-.108-2.934-.244-2.949-.41,0-.017,1.388-.7,1.406-.7,2.291.143-1.829-10.16-8.063-17.755a.11.11,0,0,1-.013-.119l1.178-2.353A.112.112,0,0,1,303.988,360.669Z",
    transform: "translate(-302.721 -360.665)",
    fill: "#6b8ba7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M316.5,360.273l.3-.015v.005c4.57-.172,8.686.173,11.405.194.389,2.171,2.134,3.921,4.127,5.224.3.428.606.856.922,1.291,2.7,3.707,4.279,6.149,2.544,10.853-1.707,4.627.147,8.718,1.88,13a108.932,108.932,0,0,0-21.72-.731c.181-3.986-1.9-8.018-2.691-11.879-.712-3.482-1.63-7.075-2.43-10.674a18.614,18.614,0,0,0,4.9-7.229C315.99,360.3,316.248,360.283,316.5,360.273Z",
    transform: "translate(-299.247 -312.311)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M335.752,377.2c-1.707,4.627.147,8.718,1.88,13a108.935,108.935,0,0,0-21.72-.731c.181-3.986-1.9-8.018-2.691-11.879-.692-3.381-1.6-6.867-2.386-10.364h23C336.137,370.463,337.345,372.878,335.752,377.2Z",
    transform: "translate(-299.203 -311.685)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M326.687,413.185s7.023,20.673-1.375,48.548c0,0-3.729,30.287-.405,54.279.176,1.278-3.9.053-3.9.053s-15.251-41.773-6.8-53.152l-8.431-43.023Z",
    transform: "translate(-285.497 -307.58)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6925",
    "data-name": "Path 6925",
    d: "M317.053,412.443c3.352-10.4,23.438,3.123,23.438,3.123a242.683,242.683,0,0,1-9.9,51.876s1.264,3.545-10.183,47.16l-3.53-4.694s-3.651-37.285,3.6-45.534C320.481,464.375,313.7,422.845,317.053,412.443Z",
    transform: "translate(-307.65 -307.998)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6926",
    "data-name": "Path 6926",
    d: "M303.954,403.478c2.837-8.43,8.01-10.662,8.491-12.756a11.466,11.466,0,0,0,.152-2.879c1.34,0,2.67-.008,3.974.008,5.693.068,11.405.046,17.091-.243,1.326-.068,2.649-.159,3.973-.259l.814,3.445c1.39,2.306,5.657,11.857,6.716,23.048.975,10.287-3.445,36.06-6.458,47.982,0,0-5.623,2.217-16.228,2.217a83.493,83.493,0,0,1-15.385-1.174C307.876,445.786,297.836,421.665,303.954,403.478Z",
    transform: "translate(-297.213 -309.887)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3701",
    "data-name": "Group 3701",
    transform: "translate(4.755 77.462)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6927",
    "data-name": "Path 6927",
    d: "M307.574,403.478c2.837-8.43,8.01-10.662,8.491-12.756a11.466,11.466,0,0,0,.153-2.879c1.34,0,2.67-.008,3.974.008,5.693.068,11.405.046,17.091-.243,1.326-.068,2.649-.159,3.973-.259l.814,3.445a43.211,43.211,0,0,1,2.911,6.567,57.131,57.131,0,0,0-7.707-.515c-8.35-.258-16.727.866-20.2,9.518-3.5,8.712-2.032,19.911-1.463,28.984.6,9.595,1.827,19.02-.132,28.18-3.084-.317-4.764-.663-4.764-.663C311.5,445.786,301.455,421.665,307.574,403.478Z",
    transform: "translate(-305.587 -387.349)",
    fill: "#1a304c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6928",
    "data-name": "Path 6928",
    d: "M308.613,500.946l8.567,17.239,4.4-.132-1.721,1.805h-10.4l-5-8.363,2.55,8.363H304.56l-5.193-12.9,3.765-9.762Z",
    transform: "translate(-270.657 -300.077)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6929",
    "data-name": "Path 6929",
    d: "M317.181,517.929l4.4-.132-1.721,1.8h-10.4l-5-8.363,2.55,8.363h-2.448l-5.193-12.9,2.637-6.648C308.844,517.972,317.181,517.929,317.181,517.929Z",
    transform: "translate(-270.658 -299.822)",
    fill: "#1a304c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6930",
    "data-name": "Path 6930",
    d: "M336.329,501l4.881,21.786H328.5L331.123,501Z",
    transform: "translate(-322.026 -299.738)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6931",
    "data-name": "Path 6931",
    d: "M330.9,517.571l6.272.422-.843-17.175,4.881,22H328.5l2.632-22.143Z",
    transform: "translate(-322.026 -299.767)",
    fill: "#1a304c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6932",
    "data-name": "Path 6932",
    d: "M315.451,360.1c3.468,6.62,7.489,13.26,10.953,20.188,0-6.609-.391-13.226-.391-19.836.232,0,4.175.28,4.175.28a84.883,84.883,0,0,1,6.12,10.951c2.4,5.3-.722,8.682-.722,8.682l5.03,12.441s-1.565,2.021-5.346,2.021c-1.891,0-7.889-1.63-7.889-1.63a11.96,11.96,0,0,1-8.475,2.282,28.888,28.888,0,0,1-8.018-2.086,19.774,19.774,0,0,0,1.044-4.825c.565-7.29-5.05-27.538-5.05-27.538C307.987,360.848,312.908,360.225,315.451,360.1Z",
    transform: "translate(-297.878 -312.321)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6933",
    "data-name": "Path 6933",
    d: "M308.8,383.828c8.163-1.057,16.29-2.365,24.45-3.386l2.964,7.33a6.728,6.728,0,0,1-5.393,2.182c-1.891,0-6.943-.771-6.943-.771s-2.29,1.968-8.048,2.246a21.851,21.851,0,0,1-7.756-.731,14.374,14.374,0,0,0,.757-3.945A20.645,20.645,0,0,0,308.8,383.828Z",
    transform: "translate(-294.78 -310.504)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702",
    transform: "translate(10.016 52.555)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6934",
    "data-name": "Path 6934",
    d: "M318.618,372.46a18.118,18.118,0,0,0,7.4,2.632c.855,1.59,1.7,3.188,2.508,4.806,0-1.519-.024-3.051-.057-4.589a51.977,51.977,0,0,0,10.8-1.04,7.661,7.661,0,0,1-1.361,5.447c-.057,0-.113.01-.17.011-8.842,6.311-10.013,1.251-13.668,4.089-.431.335-.841.675-1.234,1.02-2.167.315-4.333.632-6.492,1.005-.757.131-1.514.268-2.27.405-.212-5.915-2.642-16.2-4.06-21.761A31.586,31.586,0,0,0,318.618,372.46Z",
    transform: "translate(-310.012 -364.484)",
    fill: "#1a304c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6935",
    "data-name": "Path 6935",
    d: "M318.905,360.427s1.231-.2,1.914,6.375-3.39,13.473-3.39,13.473l-.684-19.934A5.645,5.645,0,0,1,318.905,360.427Z",
    transform: "translate(-288.904 -312.306)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6936",
    "data-name": "Path 6936",
    d: "M322.736,360.27c1.368,1.362,10.975,20.021,10.975,20.021a29.959,29.959,0,0,1-13.783-19.96C321.966,359.8,322.736,360.27,322.736,360.27Z",
    transform: "translate(-305.186 -312.323)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6937",
    "data-name": "Path 6937",
    d: "M305.91,380.309a13.184,13.184,0,0,0,1.19-.582,3.088,3.088,0,0,1,1.916,4.809,12.045,12.045,0,0,1-3.643.913A7.706,7.706,0,0,0,305.91,380.309Z",
    transform: "translate(-265.193 -310.568)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6938",
    "data-name": "Path 6938",
    d: "M330.935,380.536c1.025.173,3.089,3.827-.776,4.871s-23-1.068-23-1.068l1.4-4.145C318.23,381.941,330.935,380.536,330.935,380.536Z",
    transform: "translate(-289.98 -310.526)",
    fill: "#d8937d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(5.219 48.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6939",
    "data-name": "Path 6939",
    d: "M311.115,361.121l3.177,3.591c-.741,2.259-4.558,11.623.69,19.475a3.809,3.809,0,0,0,2.686,1.662c4.573.815,13.217-2.369,18.732-5.138a7.193,7.193,0,0,1,7.894.678c.227.581-.362,1.223-5.17,1.535,0,0-13.9,7.98-20.165,7.98a12.344,12.344,0,0,1-2.155-.181,8.783,8.783,0,0,1-5.938-3.786C304.171,376.917,309.624,362.028,311.115,361.121Z",
    transform: "translate(-307.607 -361.121)",
    fill: "#e5a185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704",
    transform: "translate(4.764 48.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6940",
    "data-name": "Path 6940",
    d: "M335.415,360.955l3.343,3.844c-.741,2.26-2.505,11.3,2.741,19.148.548.818.168,1.051,1.186,1.306a27.773,27.773,0,0,0-3.505,2.126,7.888,7.888,0,0,0-1.6,2.133,9.249,9.249,0,0,1-3.051-2.387C327.832,377.106,332.8,361.136,335.415,360.955Z",
    transform: "translate(-331.176 -360.955)",
    fill: "#6b8ba7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    d: "M331.2,376.531a38.081,38.081,0,0,1,4.937,3.772c-1.3,0-7.412-3.132-7.412-3.132S330.4,376.138,331.2,376.531Z",
    transform: "translate(-317.202 -310.861)",
    fill: "#ca806f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6942",
    "data-name": "Path 6942",
    d: "M326.614,378.861a6.169,6.169,0,0,1,3.118-1.04,24.34,24.34,0,0,1,3.707.362c-1.154-.779-4.383-1.125-5.128-1.319s-1.938-1.453-.355-1.261a21.275,21.275,0,0,1,5.816.942c2.172.837,6.485,3.261,10.4,4.52l-1.46,1.434c.533.82.882,1.623.42,1.752-.83.23-4.962,1.31-5.81.883s-1.463-1.731-2.684-1.806-2.112-.023-4.064,1.341c-1.079.755-2.039.172-1.663-.161s.4-.377,1.663-1.572a5.775,5.775,0,0,1,3.582-1.137,11.036,11.036,0,0,0-2.249-.357,6.983,6.983,0,0,0-2.929.574c-1.228.5-2.466.216-1.876-.2a12.1,12.1,0,0,1,3.238-1.73,21.569,21.569,0,0,1,3.6-.009,19.289,19.289,0,0,0-3.81-.7c-1.073.056-1.469.209-2.6.347S325.567,379.361,326.614,378.861Z",
    transform: "translate(-322.407 -310.938)",
    fill: "#d8937d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6943",
    "data-name": "Path 6943",
    d: "M334.35,383.213l2.894,1.333a3.976,3.976,0,0,0-2.283,4.142c-3.768-.53-3.883-1.539-3.883-1.539A4.423,4.423,0,0,1,334.35,383.213Z",
    transform: "translate(-320.865 -310.257)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6944",
    "data-name": "Path 6944",
    d: "M322.705,362.006l-.334-6.916a3.342,3.342,0,1,1,6.634-.33l.314,6.893Z",
    transform: "translate(-303.449 -313.115)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6945",
    "data-name": "Path 6945",
    d: "M322.666,358.6l-.17-3.514a3.342,3.342,0,1,1,6.634-.33l.178,3.669C328.255,359.117,324.474,359.738,322.666,358.6Z",
    transform: "translate(-303.574 -313.115)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6946",
    "data-name": "Path 6946",
    d: "M325.624,320.093a16.438,16.438,0,0,1,5.381.3,18.153,18.153,0,0,1,9.769,6.2,19.584,19.584,0,0,1,1.965,2.78l.078.134c4.986,8.663,4.106,22.726-5.2,28.246a14.612,14.612,0,0,1-6.588,2.077c-9.192.582-17.888-7.853-19.333-17.055C310.21,333.281,314.931,321.236,325.624,320.093Z",
    transform: "translate(-308.042 -315.902)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6947",
    "data-name": "Path 6947",
    d: "M325.627,320.093a16.438,16.438,0,0,1,5.381.3,18.152,18.152,0,0,1,9.769,6.2,19.584,19.584,0,0,1,1.965,2.78l.078.134a24.524,24.524,0,0,1,2.066,18.467A10.531,10.531,0,0,0,342.2,342.2c-7.165-5.673-14.35-5.425-18.216-12.552-1.929,6.468-10.024,11.792-12.281,13.121C310.212,333.281,314.933,321.236,325.627,320.093Z",
    transform: "translate(-308.045 -315.902)",
    fill: "#c78575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6948",
    "data-name": "Path 6948",
    d: "M342.771,340.91c.062.39-.087-.388,0,0Z",
    transform: "translate(-339.113 -314.045)",
    fill: "#c78575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6949",
    "data-name": "Path 6949",
    d: "M319.758,346.829l11.4-.92a.945.945,0,0,1,.972,1.241c-1,2.973-3.329,5.147-6.177,5.377s-5.492-1.544-6.96-4.318A.944.944,0,0,1,319.758,346.829Z",
    transform: "translate(-302.524 -313.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6950",
    "data-name": "Path 6950",
    d: "M317.137,337.5c1.2-.382,2.595.67,3.125,2.351s-.011,3.355-1.207,3.737-2.6-.669-3.125-2.35S315.941,337.879,317.137,337.5Z",
    transform: "translate(-287.363 -314.347)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6951",
    "data-name": "Path 6951",
    d: "M318.932,338.58a4.325,4.325,0,0,1,.569,1.162c.529,1.682-.011,3.355-1.207,3.737a2.388,2.388,0,0,1-2.567-1.2Q317.321,340.423,318.932,338.58Z",
    transform: "translate(-286.602 -314.243)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6952",
    "data-name": "Path 6952",
    d: "M332.669,338.5c1.208-.387,2.622.676,3.157,2.375s-.011,3.388-1.219,3.774-2.621-.675-3.156-2.374S331.461,338.891,332.669,338.5Z",
    transform: "translate(-319.835 -314.257)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6953",
    "data-name": "Path 6953",
    d: "M334.482,339.48a4.24,4.24,0,0,1,.679,1.3c.535,1.7-.011,3.388-1.219,3.774a2.48,2.48,0,0,1-2.7-1.386Q332.9,341.357,334.482,339.48Z",
    transform: "translate(-319.169 -314.162)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6954",
    "data-name": "Path 6954",
    d: "M318.682,318.4s4.688-2.983,8.125-1.94c7.16,2.174,27.139,11.213,22.158,33.956-1.584,7.234-5.03,10.5-7.917,13.241,3.743-5.113,3.582-11.867,1.984-17.525-3.186-12.721-18.255-6.88-21.932-19.25-1.842,9.455-9.476,9.344-13.645,17.6-1.014,2.01-1.292,4.8-1.606,6.908a33.233,33.233,0,0,1-.475-5.636C305.3,322.6,312.749,317.27,318.682,318.4Zm18.26,17.265c-2.879-3.62-8.66-3.95-10.986-8.279C326.487,332.551,333.509,332.755,336.942,335.665Z",
    transform: "translate(-305.373 -316.238)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6955",
    "data-name": "Path 6955",
    d: "M326.787,334.769c-2.845-1.054-5.613-2.252-7.62-4.673.591-.147,1.178-.308,1.754-.485.669-.2,1.32-.43,1.957-.674,1.7,2.056,4.991,2.9,7.653,4.208C329.305,333.734,328.056,334.28,326.787,334.769Z",
    transform: "translate(-301.178 -315.104)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M320.924,331.861c-1.077.607-2.175,1.19-3.291,1.737-2.242-1.642-5.143-2.541-7.29-4.317a19.581,19.581,0,0,0,9.682-8.035,31.237,31.237,0,0,1,6.73,6.181A19.341,19.341,0,0,1,320.924,331.861Z",
    transform: "translate(-287.79 -315.791)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M340.608,336.663a31.846,31.846,0,0,1-7.075-2.2q.309-2.493.77-4.572a29.032,29.032,0,0,0,4.3.915,32.363,32.363,0,0,0,8.095-.013C345.072,333.262,342.835,334.817,340.608,336.663Z",
    transform: "translate(-332.989 -315.019)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M340.923,340.1c1.585-.71,3.685.53,4.691,2.772s.537,4.636-1.048,5.347-3.685-.53-4.692-2.772S339.338,340.815,340.923,340.1Z",
    transform: "translate(-338.768 -314.125)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6959",
    "data-name": "Path 6959",
    d: "M323.994,345.86a3.847,3.847,0,0,0,1.524-1c2.625,5.186,7.319,9.964,12.794,11.4a16.3,16.3,0,0,0,8.992-.175,14.42,14.42,0,0,1-5.551,1.517c-6.759.428-13.247-4.023-16.784-10.067a2.277,2.277,0,0,1-.41.245c-1.563.7-3.624-.5-4.646-2.681A4.207,4.207,0,0,0,323.994,345.86Z",
    transform: "translate(-318.762 -313.682)",
    fill: "#d78c74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepTwo);
export default __webpack_public_path__ + "static/media/stepTwo.c409e96340392d28844ecffaf71fe19c.svg";
export { ForwardRef as ReactComponent };